export default {
  name: 'sanity.imageCrop',
  title: 'Image crop',
  type: 'object',
  fields: [
    {
      name: 'top',
      type: 'number',
    },
    {
      name: 'bottom',
      type: 'number',
    },
    {
      name: 'left',
      type: 'number',
    },
    {
      name: 'right',
      type: 'number',
    },
  ],
}
